const USER_GROUP_KEY = 'HOLIDAYS_USER_GROUP';

export const getUserGroup = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return localStorage.getItem(USER_GROUP_KEY) || null;
};
